package com.ijoin.platform

import androidx.compose.runtime.Composable

/**
 * Platform-specific composable for picking media files
 * Returns list of file paths/URLs
 */
@Composable
expect fun rememberMediaPicker(): MediaPickerState

data class MediaPickerState(
    val pickFiles: () -> Unit,
    val selectedFiles: List<String>
)


